import {dateField, field, LocalisableEntityData, transientField} from "@fedeltapointofsale/data-client";

export class ReportData<T> extends LocalisableEntityData<T> {

    @dateField fromDate: Date = this.getDefaultFromDate();
    @dateField toDate: Date = this.getDefaultToDate();
    @field dateRangePeriod: string = "CUSTOM";

    @transientField get startDate(): Date {
        return this.fromDate;
    }

    set startDate(fromDate: Date) {
        if (this.fromDate && fromDate) {
            this.fromDate.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        } else {
            this.fromDate = fromDate;
        }
    }

    @transientField get startTime(): Date {
        return this.fromDate;
    }

    set startTime(fromDate: Date) {
        if (this.fromDate && fromDate) {
            this.fromDate.setHours(fromDate.getHours());
            this.fromDate.setMinutes(fromDate.getMinutes());
        } else {
            this.fromDate = fromDate;
        }
    }

    @transientField get finishDate(): Date {
        return this.toDate;
    }

    set finishDate(toDate: Date) {
        if (this.toDate && toDate) {
            this.toDate.setFullYear(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
        } else {
            this.toDate = toDate;
        }
    }

    @transientField get finishTime(): Date {
        return this.toDate;
    }

    set finishTime(toDate: Date) {
        if (this.toDate && toDate) {
            this.toDate.setHours(toDate.getHours());
            this.toDate.setMinutes(toDate.getMinutes());
        } else {
            this.toDate = toDate;
        }
    }

    getDefaultFromDate(): Date {
        const defaultDate: Date = new Date();
        defaultDate.setHours(0);
        defaultDate.setMinutes(0);
        return defaultDate;

    }


    getDefaultToDate(): Date {
        const defaultDate: Date = new Date(Date.now() + (1000 * 60 * 60 * 24));
        defaultDate.setHours(0);
        defaultDate.setMinutes(0);
        return defaultDate;

    }
}
